import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.workload')
  .factory('WorkloadApi', WorkloadApi);

function WorkloadApi(): BringozApi {
  return {
    base: `/workload`,
    infiniteScroll: {
      address: `/workload`,
      cmd: 'GET'
    },
    actions: {
      getTotals: {
        address: 'totals',
        cmd: 'GET',
        updateable: true
      },
      getWorkload: {
        address: '',
        cmd: 'GET',
        updateable: false
      },
      updateWorkload: {
        address: '{workloadId}',
        updateable: false,
        cmd: 'POST'
      },
      upload: {
        address: 'totals/import',
        updateable: false,
        cmd: 'POST'
      },
      getAttendanceState: {
        address: 'attendance/state',
        updateable: false,
        cmd: 'GET'
      },
      getAttendanceFuture: {
        address: 'attendance/future',
        updateable: false,
        cmd: 'GET'
      }
    }
  }
}
